window.player = {
  currency: 0,
  lastUpdate: new Date().getTime(),
  historical: {
    gameCreatedAt: Date.now(),
    totalTimePlayed: 0,
    realTimePlayed: 0,
  }
}